import React from 'react'
import { Link } from 'react-router-dom'

/** Company divisions - internal routes use React Router; absolute URLs open in a new tab */
const divisionLinks = [
    // { label: 'Precision Fluid Controls', to: '/' },
    { label: 'Autoflow Products', to: 'https://autoflowproducts.com/' },
    // { label: 'Sierra Precision Machining', to: 'https://www.sierraprecisionmachining.com/' },
    { label: 'Martin Testing Laboratory', to: 'https://martintestinglabs.com/' },
]

const isExternalUrl = (path) => /^https?:\/\//i.test(path)

/**
 * Primary site footer: divisions + contact CTA. Rendered on every v2 page via V2Layout.
 */
const V2UniversalFooter = () => {
    return (
        <section className="v2-cta" id="contact">
            <div className="v2-cta-inner">
                <div className="v2-cta-divisions">
                    <p className="v2-section-label">
                        Company Divisions
                    </p>
                    <nav className="v2-cta-division-links" aria-label="Company divisions">
                        {divisionLinks.map(({ label, to }) =>
                            isExternalUrl(to) ? (
                                <a
                                    key={label}
                                    href={to}
                                    className="v2-cta-division-link"
                                    target="_blank"
                                    rel="noopener noreferrer"
                                >
                                    {label}
                                </a>
                            ) : (
                                <Link key={label} to={to} className="v2-cta-division-link">
                                    {label}
                                </Link>
                            )
                        )}
                    </nav>
                </div>
                <div className="v2-cta-main">
                    <p className="v2-section-label">
                        Get in Touch
                    </p>
                    <h2 className="v2-cta-title">How Can We Help You?</h2>
                    <p className="v2-cta-sub">
                        Tell us about your project. Our engineering team is ready to find the right
                        fluid control solution for your application.
                    </p>
                    <div className="v2-cta-actions">
                        <Link to="/contactus" className="v2-btn-primary">Get in Touch with Us</Link>
                        <Link to="/about" className="v2-btn-outline">Learn About PFC</Link>
                    </div>
                </div>
            </div>
        </section>
    )
}

export default V2UniversalFooter
